import { REMOVE_FROM_LIST, REMOVE_ALL } from "../types";

export const removeFromList = newList => {
  return {
    type: REMOVE_FROM_LIST,
    newList
  };
};

export const removeAll = () => {
  return {
    type: REMOVE_ALL,
    graph : []
  };
};
